// imports section Start
import React from "react";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../../assets/styles/Theme";
import no_image from "../../../assets/images/no_image.png";
import {
  Typography,
  Card,
  CardContent,
  CardMedia,
  CardActionArea,
  Box,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { addCashierItemToCart } from "../../../store/ReduxCashierCartReducer";
// imports section End

export default function CashierItemCard({
  cashierItem,
  IMAGEBASEURL,
  onViewOrder,
}) {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  const dispatch = useDispatch();
  // Hooks end

  // Handlers start
  const handleAddToCart = () => {
    dispatch(addCashierItemToCart(cashierItem));
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "LKR",
    }).format(price);
  };
  // Handlers end

  return (
    <Card sx={styles.cs_card}>
      <CardActionArea sx={styles.cs_card_actions} onClick={handleAddToCart}>
        <CardMedia
          component="img"
          image={
            cashierItem.IMAGEPATH
              ? `${IMAGEBASEURL}${cashierItem.IMAGEPATH.replace("~", "")}`
              : no_image
          }
          alt={cashierItem.ENUSER || "Product Image"}
          sx={styles.cs_card_media}
        />
        <CardContent sx={styles.cs_card_content}>
          <Typography
            sx={{
              ...theme.typography.caption,
              ...styles.text_center,
              color: theme.palette.text.primary,
              paddingBottom: "5px",
              borderBottom: "1px solid",
              borderColor: theme.palette.stroke.main,
              fontWeight: "800",
              // position: "absolute",
              marginTop: "-3rem",
              // marginRight: "0",
              zIndex: 1000,
              textAlign: "right",
              mr: 2,
            }}
            gutterBottom
            component="div"
          >
            {cashierItem.MENUREFCODE}
          </Typography>
          <Box textAlign={"left"} pt={4} mt={3}>
            <Typography
              noWrap
              p={"2px 20px"}
              sx={{
                ...theme.typography.body2,
                // ...styles.text_center,
                color: theme.palette.text.primary,
                fontWeight: "500",
              }}
            >
              {cashierItem.MENUNAME}
            </Typography>
            <Typography
              noWrap
              p={"2px 20px"}
              sx={{
                ...theme.typography.body1,
                // ...styles.text_center,
                color: theme.palette.input_field.text,
                fontWeight: "800",
              }}
            >
              {formatPrice(cashierItem.RATE)}
            </Typography>
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
